import React from 'react';
import CoverImageSecond from './CoverImageSecond';
import Service3 from './Service3';
import Service3Second from './Service3Second';
import ReservationForm from './ReservationForm';


import Footer from './Footer';


const Special = () => {
    return (
        <div>
            <CoverImageSecond />
            <Service3 />
            <Service3Second />
            <ReservationForm />

            <Footer/>

        </div>
    );
};

export default Special;